import { compose } from 'recompose';

import SelectView from './SelectView';

export default compose()(SelectView);
